import Types from 'Types';

export const getQuantity = (state: Types.RootState) => {
  return state.checkoutOptions.quantity;
};
